import React from 'react';
import Lazyload from 'react-lazyload';
import { push } from '../../../native/navigator';
import { resloveUrl, Webp } from '../formateImage';
import { sendStatsEvent } from '../../statistics';
import Detector from '../../../utils/detector';

export default class ReserveList extends React.Component {
  render(){
    let { reserveInfo } = this.props;
    if(!reserveInfo || reserveInfo.list.length === 0 ) return null;
    return (
      <div className="reserve-wrap">
        {/* <h4>相关预定</h4> */}
        <ul className="reserve-list">
          {
            reserveInfo.list.map((item, index) =>{
              return(
                <Item
                  key={index}
                  item={item} 
                  handleClick={this.goToPoiSalePage}/>
              );
            })
          }
        </ul>
        {
          reserveInfo.list && reserveInfo.list.length >=3 ?
            <p className={`reserve-more ${Detector.os.name}`} onClick={this.goToViewMore}>
            查看更多<i className="icon icon-arrow"></i> 
            </p>
            : null
        } 
       
      </div>
    );
  }

  goToPoiSalePage = (url)=>{
    sendStatsEvent('poi_booking_click');
    push(url);
  }
  
  goToViewMore = ()=>{
    let { reserveInfo } = this.props;
    sendStatsEvent('poi_allbooking_click');
    push(reserveInfo.more);
  }
  
}

function Item(props){
  let { item,handleClick } = props;
  let img = resloveUrl(item.img);
  return (
    <li className="reserve-item" onClick={()=>{
      handleClick(item.url);
    }}>
      <div className="item-inner">
        <div className="reserve-image">
          <Lazyload><img src={Webp(`${img}/both/210x160`)} alt={item.goods_name}/></Lazyload>
        </div>
        <div className="reserve-detail">
          <h5 className="reserve-name">{item.goods_name}</h5>
          <div className="tickets">
            {item.ticketing_time ? <span className="ticket">{item.ticketing_time}</span> : null}
          </div>
          <div className="price-count">
            <p className="price">
              <strong>¥{item.min_final_price}</strong>起
              <s className="origin-price">¥{item.min_retail_price}</s>
            </p>

            <span className="detail"><b>{item.sales_volume}</b>人推荐</span>
          </div>
        </div>
      </div>
    </li>
  );
}







// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/ReserveList.js